/**
 * BarmetVault Cryptographic Parameters
 * All parameters are versioned for future migration.
 */
export const CRYPTO_SCHEME_VERSION = 1;

// Argon2id - master key derivation from master password
export const KDF_PARAMS: Readonly<{
  algorithm: 'argon2id';
  memoryLimit: number;
  iterations: number;
  parallelism: number;
  saltBytes: number;
  keyBytes: number;
}> = {
  algorithm: 'argon2id',
  memoryLimit: 64 * 1024 * 1024,
  iterations: 3,
  parallelism: 4,
  saltBytes: 16,
  keyBytes: 32,
};

// PBKDF2-SHA256 - auth hash (travels to server)
export const AUTH_HASH_PARAMS: Readonly<{
  algorithm: 'PBKDF2-SHA256';
  iterations: number;
  saltBytes: number;
  keyBytes: number;
}> = {
  algorithm: 'PBKDF2-SHA256',
  iterations: 600_000,
  saltBytes: 16,
  keyBytes: 32,
};

// XChaCha20-Poly1305 - symmetric encryption
export const SYMMETRIC_PARAMS: Readonly<{
  algorithm: 'xchacha20-poly1305-ietf';
  nonceBytes: number;
  keyBytes: number;
}> = {
  algorithm: 'xchacha20-poly1305-ietf',
  nonceBytes: 24,
  keyBytes: 32,
};

// Ed25519 - digital signatures
export const SIGNATURE_PARAMS: Readonly<{
  algorithm: 'Ed25519';
  seedBytes: number;
}> = {
  algorithm: 'Ed25519',
  seedBytes: 32,
};

// X25519 - key agreement (ECDH)
export const KEY_AGREEMENT_PARAMS: Readonly<{
  algorithm: 'X25519';
  seedBytes: number;
}> = {
  algorithm: 'X25519',
  seedBytes: 32,
};

// HKDF - key derivation after ECDH
export const HKDF_PARAMS: Readonly<{
  algorithm: 'SHA-256';
  saltBytes: number;
  infoPrefix: string;
}> = {
  algorithm: 'SHA-256',
  saltBytes: 32,
  infoPrefix: 'barmetvault-share-v1',
};

// Shamir Secret Sharing
export const SHAMIR_PARAMS: Readonly<{
  shares: number;
  threshold: number;
}> = {
  shares: 5,
  threshold: 3,
};

// TOTP
export const TOTP_PARAMS: Readonly<{
  algorithm: 'SHA-1';
  digits: number;
  period: number;
}> = {
  algorithm: 'SHA-1',
  digits: 6,
  period: 30,
};

export const CLIPBOARD_CLEAR_SECONDS = 30;
export const ACCESS_TOKEN_TTL_SECONDS = 5 * 60;
export const REFRESH_TOKEN_TTL_SECONDS = 7 * 24 * 3600;
export const MAX_CONCURRENT_SESSIONS = 3;
export const IDLE_TIMEOUT_SECONDS = 15 * 60;
